import React, {useState} from 'react'
import {useSelector} from 'react-redux'
import {NavLink} from 'react-router-dom'
import loadable from '@loadable/component'
import Badges from './Badges'
import Image from './Image'
import DesignImage from './DesignImage'

import styles from './product.module.scss'

const AdminSetup = loadable(() => import('./AdminSetup'))

/** @param {import('./index').ProductProps} props */
export default function Product(props) {
    const {
        product,
        authenticityToken,
        tags,
        onPlatform,
        lazyImg,
        openModal,
    } = props

    const [adminIsOpen, setAdminIsOpen] = useState(false)
    const [isShowDesignImage, setIsShowDesignImage] = useState(false)

    const isMobile = useSelector((state) => state.isMobile)

    const showDesignImage = () => setIsShowDesignImage(true)

    const hideDesignImage = () => setIsShowDesignImage(false)

    const productClick = () => {
        typeof window === 'object' && window.scrollTo(0, 0);
    }

    const currency = (
        <abbr
            className="currency"
            itemProp="priceCurrency"
            content="RUB"
            title="RUB"
        >
            Руб
        </abbr>
    )

    const price = (
        <Choose>
            <When
                condition={
                    product.price.basePrice === product.price.currentPrice
                }
            >
                <span itemProp="price">
                    {product.price.basePrice} {currency}
                </span>
            </When>
            <Otherwise>
                <span className="product__price_through">
                    {product.price.basePrice} {currency}
                </span>
                <span> </span>
                <span className="product__price_discount" itemProp="price">
                    {product.price.currentPrice} {currency}
                </span>
            </Otherwise>
        </Choose>
    )

    return (
        <div
            className="product"
            onMouseLeave={() => setAdminIsOpen(false)}
            onMouseEnter={() => setAdminIsOpen(true)}
            itemScope={true}
            itemType="http://schema.org/Product"
        >
            <If condition={product.admin && adminIsOpen}>
                <AdminSetup
                    id={product.id}
                    content={product.admin}
                    authenticityToken={authenticityToken}
                    tags={tags}
                />
            </If>
            <div className="product__edit">
                <a href={product.editPath}>
                    <i className="fas fa-pencil-alt" />
                </a>
            </div>
            <If condition={product.badges}>
                <div className="product__badges">
                    <Badges badges={product.badges} />
                </div>
            </If>
            <div className="product__design">
                <If condition={product.admin}>
                    <div className="sorting-boost">
                        {product.admin.formulaForSortingWeightBoost}
                    </div>
                </If>
                <div className="product__img">
                    <NavLink to={product.path} onClick={productClick}>
                        <Image
                            className={styles.previewImg}
                            src={product.preview.assetURL}
                            alt={product.preview.alt}
                            title={product.preview.title}
                            ready={product.ready}
                            lazy={lazyImg}
                            onMouseEnter={showDesignImage}
                        />
                        <If condition={!isMobile && isShowDesignImage}>
                            <DesignImage
                                product={product}
                                hideDesignImage={hideDesignImage}
                            />
                        </If>
                        <meta
                            itemProp="image"
                            content={product.preview.assetURL}
                        />
                    </NavLink>
                </div>
                <div className="product__meta">
                    <div className="product__title">
                        <a href={product.path}>{product.title}</a>
                        <meta itemProp="name" content={product.title} />
                        <meta
                            itemProp="description"
                            content={product.preview.alt}
                        />
                        <meta itemProp="sku" content={product.id} />
                        <meta itemProp="mpn" content={product.id} />
                        <meta itemProp="brand" content="printio" />
                    </div>
                    <div
                        className="product__price"
                        itemProp="offers"
                        itemScope={true}
                        itemType="http://schema.org/Offer"
                    >
                        {price}
                        <link
                            itemProp="availability"
                            href="http://schema.org/InStock"
                        />
                        <meta
                            itemProp="itemCondition"
                            content="http://schema.org/NewCondition"
                        />
                        <meta itemProp="url" content={product.path} />
                        <meta
                            itemProp="image"
                            content={product.preview.assetURL}
                        />
                    </div>
                </div>
                <If condition={onPlatform !== 'vtb'}>
                    <div className="product__buy">
                        <button
                            className="b-btn b-btn_danger"
                            onClick={openModal}
                            data-id={product.id}
                        >
                            Купить в 1 клик
                        </button>
                    </div>
                </If>
            </div>
        </div>
    )
}
